import {countdownParts, CountdownParts, daysLeftUntil, LisansDurumUrun} from "@/utils/renewalOffer";

/**
 * Demo (ücretsiz deneme) lisansı durumu — /api/v1/ben yanıtındaki `lisans_durum`
 * özetinden türetilir (eski kaynak: GET /api/v1/demo-status).
 *
 * Yenileme teklifinden farkı: kademe yoktur, demo süresi boyunca hep gösterilir
 * ve süre dolduğunda da (`expired`) bar kaybolmaz; kullanıcı "Hemen Al" ile
 * satın almaya gidebilsin.
 */
export interface DemoStatus {
    active: boolean;
    days_left: number | null;
    end_date: string | null;
    expired: boolean;
    package_name: string | null;
}

/**
 * GET /api/v1/demo-status yanıt şekli. Uygulama artık bu ucu ÇAĞIRMIYOR
 * (veri /ben içindeki `lisans_durum` ile geliyor); uç geriye dönük uyumluluk
 * için API'de durduğundan sözleşme burada korunur.
 */
export interface DemoStatuses {
    icrapro: DemoStatus;
    eicrapro: DemoStatus;
}

/**
 * `/ben` özetindeki ham satırdan demo durumu. Demo değilse null.
 *
 * `days_left` ve `expired` burada, her okumada yeniden hesaplanır: özet
 * sessionStorage'da sekme kapanana kadar yaşadığı için backend'de hesaplanmış
 * bir gün sayısı gece yarısı bayatlardı.
 *
 * Süresi dolmuş demoda da durum döner — bar kaybolmamalı, kullanıcı hâlâ
 * "Hemen Al" ile satın almaya gidebilmeli.
 */
export function demoStatusFromLisansDurum(
    urun: LisansDurumUrun | null | undefined,
    now: Date = new Date()
): DemoStatus | null {
    if (!urun || !urun.demo || !urun.end_date) {
        return null;
    }

    const daysLeft = daysLeftUntil(urun.end_date, now);

    return {
        active: true,
        days_left: daysLeft,
        end_date: urun.end_date,
        expired: daysLeft < 0,
        package_name: urun.package_name,
    };
}

export const DEMO_BASLIK_AKTIF = 'Demo sürenizin bitmesine kalan süre';
export const DEMO_BASLIK_BITTI = 'Demo süreniz doldu';

const SIFIR_SAYAC: CountdownParts = {gun: 0, saat: 0, dakika: 0, saniye: 0, bitti: true};

/** Aktif demo ise durumu, değilse null döner (tip daraltma için). */
function aktifDemo(status: DemoStatus | null | undefined): DemoStatus | null {
    return status && status.active === true ? status : null;
}

/** Demo lisansı var mı? Süresi dolmuş olsa bile bar görünür. */
export function demoBarVisible(status: DemoStatus | null | undefined): boolean {
    return aktifDemo(status) !== null;
}

/** Geri sayım hâlâ işliyor mu? (false ise sayaç yerine "süreniz doldu" metni gösterilir) */
export function demoSayacAktif(status: DemoStatus | null | undefined, now: Date = new Date()): boolean {
    const demo = aktifDemo(status);
    if (!demo || demo.expired || !demo.end_date) {
        return false;
    }
    // İstemci saati backend'in `expired` bayrağından ileri olabilir; ikisi de kontrol edilir.
    return !countdownParts(demo.end_date, now).bitti;
}

/** Bardaki ana başlık. */
export function demoBarBaslik(status: DemoStatus | null | undefined, now: Date = new Date()): string {
    return demoSayacAktif(status, now) ? DEMO_BASLIK_AKTIF : DEMO_BASLIK_BITTI;
}

/** Sayaç parçaları; demo yoksa ya da süre dolduysa sıfırlanmış (bitti=true) değer döner. */
export function demoCountdownParts(status: DemoStatus | null | undefined, now: Date = new Date()): CountdownParts {
    const demo = aktifDemo(status);
    if (!demo || !demo.end_date || !demoSayacAktif(demo, now)) {
        return {...SIFIR_SAYAC};
    }
    return countdownParts(demo.end_date, now);
}
